"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    // Standard Elements
    'area',
    'base',
    'br',
    'col',
    'embed',
    'hr',
    'img',
    'input',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr',
    // SVG Elements
    'circle',
    'ellipse',
    'line',
    'path',
    'polygon',
    'polyline',
    'rect',
    'stop',
    'use'
];
//# sourceMappingURL=SelfClosingElements.js.map